/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AnalyticsOrganizationEventsListParams,
  OrganizationEvents,
  OrganizationEventsRequest,
  PaginatedOrganizationEventsList
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const analyticsOrganizationEventsList = (
    params?: AnalyticsOrganizationEventsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedOrganizationEventsList>>,) => {
      return apiV2<PaginatedOrganizationEventsList>(
      {url: `/analytics/organization-events/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const analyticsOrganizationEventsCreate = (
    organizationEventsRequest: OrganizationEventsRequest,
 options?: SecondParameter<typeof apiV2<OrganizationEvents>>,) => {
      return apiV2<OrganizationEvents>(
      {url: `/analytics/organization-events/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationEventsRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const analyticsOrganizationEventsRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<OrganizationEvents>>,) => {
      return apiV2<OrganizationEvents>(
      {url: `/analytics/organization-events/${id}/`, method: 'GET'
    },
      options);
    }
  export type AnalyticsOrganizationEventsListResult = NonNullable<Awaited<ReturnType<typeof analyticsOrganizationEventsList>>>
export type AnalyticsOrganizationEventsCreateResult = NonNullable<Awaited<ReturnType<typeof analyticsOrganizationEventsCreate>>>
export type AnalyticsOrganizationEventsRetrieveResult = NonNullable<Awaited<ReturnType<typeof analyticsOrganizationEventsRetrieve>>>
